// styled
import usePageStore from "store/usePageStore";
import { StyledSubTab } from "./style";
// library
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { NavSubMenuProps } from "const/const";

interface SubTabProps {
  tabMenu: NavSubMenuProps[];
}

function SubTab({ tabMenu }: SubTabProps) {
  const locationPath = useLocation().pathname.split("/")[2];

  return (
    <StyledSubTab $enabled={"enabled"}>
      <div className="tabbar-container">
        <div className="tabbar-group">
          {tabMenu?.map((tab: NavSubMenuProps, idx: number) => (
            <Link
              key={idx}
              to={tab.path}
              className={`tabbar-item${
                locationPath === tab.key ? " active" : ""
              }`}
            >
              <p>{tab.title}</p>
            </Link>
          ))}
        </div>
      </div>
    </StyledSubTab>
  );
}

export default SubTab;
